import { render, staticRenderFns } from "./LogoFinder.vue?vue&type=template&id=f082dd38"
import script from "./LogoFinder.vue?vue&type=script&lang=js"
export * from "./LogoFinder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports